<template>
  <div class="formsContainer">
    <component
      :key="updated"
      v-if="objectLayer"
      style="z-index: 150"
      :is="openedFormComponent(objectLayer)"
      :object-data="selectedObjectData"
      :object-layer="objectLayer"
      @close="closeForm()"
    />
  </div>
</template>

<script>
import CabinetForm from "@/components/Network/Forms/ObjectForms/CabinetForm";
import CableForm from "@/components/Network/Forms/ObjectForms/CableForm";
import ChamberForm from "@/components/Network/Forms/ObjectForms/ChamberForm";
import ClosureAreaForm from "@/components/Network/Forms/ObjectForms/ClosureAreaForm";
import ClosureForm from "@/components/Network/Forms/ObjectForms/ClosureForm";
import COAreaForm from "@/components/Network/Forms/ObjectForms/COAreaForm";
import COForm from "@/components/Network/Forms/ObjectForms/COForm";
import PathwayForm from "@/components/Network/Forms/ObjectForms/PathwayForm";
import PNAreaForm from "@/components/Network/Forms/ObjectForms/PNAreaForm";
import PNForm from "@/components/Network/Forms/ObjectForms/PNForm";
import PoleForm from "@/components/Network/Forms/ObjectForms/PoleForm";
import TobyBoxForm from "@/components/Network/Forms/ObjectForms/TobyBoxForm";
import BuildingForm from "@/components/Network/Forms/ObjectForms/BuildingForm";
import TechnicalLocalForm from "@/components/Network/Forms/ObjectForms/TechnicalLocalForm";
import BlockageForm from "@/components/Network/Forms/ObjectForms/BlockageForm";
export default {
  name: "ObjectForm",

  components: {
    CabinetForm,
    CableForm,
    ChamberForm,
    ClosureAreaForm,
    ClosureForm,
    COAreaForm,
    COForm,
    PathwayForm,
    PNAreaForm,
    PNForm,
    PoleForm,
    TobyBoxForm,
    BuildingForm,
    TechnicalLocalForm,
    BlockageForm,
  },

  data() {
    return {
      /**
       * Data of selected object
       */
      selectedObjectData: null,

      /**
       * Name of the layer of the object for which the form was opened.
       */
      objectLayer: null,

      /**
       * Used to update components with current information
       */
      updated: 0
    };
  },

  methods: {
    openNewForm(layer, objectData) {
      this.selectedObjectData = objectData;
      this.objectLayer = layer;
      this.updated++;
    },

    /**
     * Determines which component corresponds to each layer
     * @param openedForm
     * @returns {string}
     */
    openedFormComponent(openedForm) {
      let objectComponent;
      if (openedForm !== "") {
        switch (openedForm) {
          case "fc_pole":
            objectComponent = "Pole";
            break;
          case "fc_manhole":
            objectComponent = "Chamber";
            break;
          case "fc_cabinet":
            objectComponent = "Cabinet";
            break;
          case "fc_toby_box":
            objectComponent = "TobyBox";
            break;
          case "fc_building":
            objectComponent = "Building";
            break;
          case "fc_pathway":
            objectComponent = "Pathway";
            break;
          case "fc_closure":
            objectComponent = "Closure";
            break;
          case "fc_cable":
            objectComponent = "Cable";
            break;
          case "fc_fiber_distribution_point":
            objectComponent = "PN";
            break;
          case "fc_optical_line_termination":
            objectComponent = "CO";
            break;
          case "fc_fdp_zone":
            objectComponent = "PNArea";
            break;
          case "fc_olt_zone":
            objectComponent = "COArea";
            break;
          case "fc_closure_zone":
            objectComponent = "ClosureArea";
            break;
          case "fc_technical_local_olt":
          case "fc_technical_local_fdp":
            objectComponent = "TechnicalLocal";
          case "fc_blockage":
            objectComponent = "Blockage";
        }
        return objectComponent + "Form";
      } else return "";
    },

    /**
     * Close form
     */
    closeForm() {
      this.objectLayer = null;
      this.form = null;
    }
  }
};
</script>

<style scoped>
.formsContainer {
  position: absolute;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Forms/ObjectForm.vue